import api from '@pray/shared/utils/api';
import type { ListResponse } from '@pray/shared/utils/api/types/response';

import type { FeatureFlag } from './types';

type ApiFeatureFlag = {
  flagId: string;
  name: string;
  description: string | null;
  enabled: boolean;
  targeting?: {
    platforms?: string[];
    appTypes?: string[];
    artistIds?: string[];
    excludedArtistIds?: string[];
    geoCountries?: string[];
    userIds?: string[];
    artistDetails?: { id: string; name: string }[];
    excludedArtistDetails?: { id: string; name: string }[];
    userDetails?: { id: string; email: string }[];
  };
  createdAt?: number;
  updatedAt?: number;
};

function mapFlag(raw: ApiFeatureFlag): FeatureFlag {
  return {
    id: raw.flagId,
    flag_id: raw.flagId,
    name: raw.name,
    description: raw.description,
    enabled: raw.enabled,
    platforms: (raw.targeting?.platforms ?? []) as FeatureFlag['platforms'],
    app_types: (raw.targeting?.appTypes ?? []) as FeatureFlag['app_types'],
    artist_ids: raw.targeting?.artistIds ?? [],
    excluded_artist_ids: raw.targeting?.excludedArtistIds ?? [],
    geo_countries: raw.targeting?.geoCountries ?? [],
    user_ids: raw.targeting?.userIds ?? [],
    artist_details: raw.targeting?.artistDetails,
    excluded_artist_details: raw.targeting?.excludedArtistDetails,
    user_details: raw.targeting?.userDetails,
    created_at: raw.createdAt ? new Date(raw.createdAt).toISOString() : '',
    updated_at: raw.updatedAt ? new Date(raw.updatedAt).toISOString() : '',
  };
}

export const getFeatureFlags = async () => {
  const url = '/web/studio/feature-flags';
  const response = await api.executeGetRequest<ListResponse<ApiFeatureFlag>>(url);
  return {
    ...response.data,
    data: (response.data?.data ?? []).map(mapFlag),
  };
};
